// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import Component from "../../../../app/lib/jGia/jGia/src/Component";
import eventbus from "../../../../app/lib/jGia/jGia/src/eventbus";
import gsap from "gsap";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import logger from "../../../../app/baseUtilities/logger";
import validate_refEl from "../../../../app/baseUtilities/validate/validate_refEl.js";
import cancel_featureInit from "../../../../app/baseUtilities/cancel/cancel_featureInit";
import cancel_ebh from "../../../../app/baseUtilities/cancel/cancel_ebh.js";

// —————————————————————————————————————— INITIALIZATION F() —————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// import { get_viewportState } from "../../../assets/js/init/init_viewportState";

// ——————————————————————————— EVENT/EVENTBUS/STATE CHANGE HANDLERS/API ——————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// import ebh_window_resize from "./eventbusHandlers/ebh_window_resize.js";

// import stChH_mode from "./stateChangeHandlers/stChH_mode.js";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// Options with case-sensitive keys that are not to be
// automatically extracted from the options arg. but be
// assigned to an option key manually to preserve its case
// (Kirby CMS converts all fields/option keys to lowercase)
// (see constructor).

const manualOptionKeys = ["optionkey"];

//  Default values for manually extracted options
//  (see constructor, in case specific option has not been provided
//  in comp. config.).

const defaultOptions = {
  optionkey: { foo: "bar" },
};

// Default log styles

const defaultLogStyles = {
  default: "#6682d6",
  action: "#c7d0ff",
  event: "#97a5ce",
  warning: "#ffaf00",
  error: "#ff3232",
  success: "#00c853",
};

// ——————————————————————————————————————— COMP. DEFINITION ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

class PopUp extends Component {
  ///////////////////////////////////////// Constructor //////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(element, options) {
    super(element);

    //////////////////////////// DOM references ////////////////////////////
    ////////////////////////////////////////////////////////////////////////

    this.ref = {
      link: null,
      btn_close: null,
    };

    /////////////////////////////// Options ////////////////////////////////
    ////////////////////////////////////////////////////////////////////////

    // Get options not to be manually extracted from the options arg...
    const autoOptions = {};
    for (const key in options) if (!manualOptionKeys.includes(key)) autoOptions[key] = options[key];

    this.options = {
      name: "PopUp",
      // optionKey: options.optionkey,
      ...autoOptions,
      run_withLogs: false,
      logStyles: defaultLogStyles,
    };

    ////////////////////////////// Utilities ///////////////////////////////
    ////////////////////////////////////////////////////////////////////////

    this.logger = logger.bind(this);
    this.validate_refEl = validate_refEl.bind(this);
    this.cancel_featInit = cancel_featureInit.bind(this);
    this.cancel_ebh = cancel_ebh.bind(this);

    ////////////////////////////// Init. f() ///////////////////////////////
    ////////////////////////////////////////////////////////////////////////

    // this.init_breakpoints = init_breakpoints.bind(this); // DEPREC

    /////////////////////////////// Modules ////////////////////////////////
    ////////////////////////////////////////////////////////////////////////

    this.modules = {
      // ...
    };

    ///////////////////////////////// API //////////////////////////////////
    ////////////////////////////////////////////////////////////////////////

    this.api = {
      // ...
    };

    ////////////////////////// Eventbus listeners //////////////////////////
    ////////////////////////////////////////////////////////////////////////

    // this.ebl_window_resize = ebh_window_resize.bind(this); // NOT NEEDED ATM

    //////////////////////// State-change listeners ////////////////////////
    ////////////////////////////////////////////////////////////////////////

    // this.stChL_mode = stChH_mode.bind(this); // NOT NEEDED ATM

    //////////////////////// Custom event handlers /////////////////////////
    //////////////////// (To be passed to parent class) ////////////////////

    // ...

    /////////////////////////// Pre-mount init. ////////////////////////////
    ////////////////////////////////////////////////////////////////////////

    // ...
  }

  //////////////////////////////////////////// Mount /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  mount() {
    this.logger("info", ["mounting"], "action", { eventName: "mount", inline: true });
    this.init();
  }

  /////////////////////////////////////////// Unmount ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  unmount() {
    this.logger("info", ["unmounting"], "action", { eventName: "unmount", inline: true });

    // Eventbus listener de-registration //
    // eventbus.off("window_resize", this.ebl_window_resize); // NOT NEEDED ATM

    // API call de-registration //
    // ...
  }

  //////////////////////////////////////////// Init. /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////// Base init. //////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  init() {
    // this.setState({ mode: "init" }); // NOT NEEDED ATM
    // this.init_states(); // NOT NEEDED ATM
    // this.init_breakpoints(); // DEPREC
    // this.init_eventbus(); // NOT NEEDED ATM
    // this.setState({ mode: "ready" }); // NOT NEEDED ATM

    ////// Random position init. ///////
    ////////////////////////////////////

    // Set random position within the left third of viewport
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const size = 200;
    const leftThirdWidth = vw / 3 - size; // Left third minus popup size
    const x = Math.random() * Math.max(leftThirdWidth, 0); // Ensure x is not negative
    const y = Math.random() * (vh - size);
    this.element.style.top = `${y}px`;
    this.element.style.left = `${x}px`;
    setTimeout(() => gsap.to(this.element, { duration: 0.3, opacity: 1, ease: "power2.out" }), 250);

    ///////// Draggable init. //////////
    ////////////////////////////////////

    // TO DO...

    //////////// Link init. ////////////
    ////////////////////////////////////

    // if (this.ref.link) {
    //   this.ref.link.addEventListener("click", () => {
    //     gsap.to(this.element, {
    //       duration: 0.3,
    //       opacity: 0,
    //       ease: "power2.out",
    //       onComplete: () => (this.element.style.display = "none"),
    //     });
    //   });
    // }

    // Close btn. init. //
    ////////////////////////////////////

    if (this.ref.btn_close) {
      this.ref.btn_close.addEventListener("click", () => {
        this.element.classList.remove("transition-transform", "duration-300");
        gsap.to(this.element, {
          duration: 0.3,
          scale: 0,
          onComplete: () => (this.element.style.display = "none"),
        });
      });
    }
  }

  ///////////////////////////// States init. /////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  // NOT NEEDED ATM //
  // init_states() {
  //   this.logger("init", ["states"], "action", { eventName: "init_states", inline: true });
  //   this.setState({ features: { mouse: window.matchMedia("(pointer:fine)").matches } });
  // }

  //////////////////////////// Eventbus init. ////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  // NOT NEEDED ATM //
  // init_eventbus() {
  //   this.logger("init", ["eventbus"], "action", { eventName: "init_eventbus", inline: true });

  //   // Listener registration //
  //   eventbus.on("window_resize", this.ebl_window_resize);

  //   // API call registration //
  //   // ...
  // }

  ///////////////////////////////////////// State mgmt. //////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  stateChange(CHANGES) {
    // if ("mode" in CHANGES) this.stChL_mode(CHANGES);
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default PopUp;
